
/* injects from baggage-loader */
var Template = require('./template.js');

import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Zergling from '../../../helpers/zergling';
import { BoostedTypes } from '../../components/event/boostedEnum'
class BoostedOdds extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            boostedOddsState: null
        };
    }
    componentDidMount () {
        Zergling.get({}, "get_boosted_selections").then((resp) => {
            const games = {}

            for (const gameId in resp.details) {
                const markets = resp.details[gameId]    
                const gameHasBoostedMarket = markets.some(market => [BoostedTypes.Both, BoostedTypes.Prematch].includes(market.BoostType))
    
                if (gameHasBoostedMarket) games[gameId] = resp.details[gameId]
            }

            this.setState({
                boostedOddsState: games
            })
        });
    }
    render () {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

// const mapStateToProps = (_, ownParams) => {
//     return createSelector(
//         [
//             state => state.terminal.boostedOddsGameIds,
//         ],
//         (boostedOddsGameIds) => {
//             return {
//                 boostedOddsGameIds
//             };
//         }
//     );
// };

// export default connect(mapStateToProps)(BoostedOdds);

export default BoostedOdds